<template>
  <div
    id="SubCategoriesLinks"
    class="subCategoryLinks"
    data-testid="sbx-pcc_subCategoriesLinks"
    :style="cssProps"
    v-if="computedProps && computedProps.length"
  >
    <ul class="subCategoryLinks__list" :class="subCatAspect" v-bind="computedProps">
      <li class="subCategoryLinks__item" v-for="(item, index) in computedProps" :key="`subCategoryLinks__item-${index}`">
        <a :href="baseUrl() + item.link" :title="item.title"> {{ item.title }} </a>
      </li>
    </ul>
  </div>
</template>

<script lang="js">
import { subCategoriesLinks } from './index.js';
import { baseUrl } from '@/SharedFe/utils/urlUtils';

export default {
  name: 'subCategoriesLinks',
  props: {
    ...subCategoriesLinks.propTypes,
  },
  data() {
    return {
      baseUrl,
    };
  },
  computed: {
    computedProps() {
      let parsedItems = [];
      if (this.items === '') return parsedItems;
      parsedItems =
        typeof this.items === 'string'
          ? JSON.parse(this.items)
          : this.items;
      return parsedItems;
    },
    cssProps() {
      return {
        '--textColor': this.subCatTextColor ? this.subCatTextColor
          : subCategoriesLinks.propTypes.subCatTextColor.default,
        '--hoverTextColor': this.subCatHoverTextColor ? this.subCatHoverTextColor
          : subCategoriesLinks.propTypes.subCatHoverTextColor.default,
        '--bgColor': this.subCatBackgroundColor ? this.subCatBackgroundColor
          : subCategoriesLinks.propTypes.subCatBackgroundColor.default,
        '--hoverBgColor': this.subCatHoverBackgroundColor ? this.subCatHoverBackgroundColor
          : subCategoriesLinks.propTypes.subCatHoverBackgroundColor.default,
        '--borderColor': this.subCatBorderColor ? this.subCatBorderColor
          : subCategoriesLinks.propTypes.subCatBorderColor.default,
        '--hoverBorderColor': this.subCatHoverBorderColor ? this.subCatHoverBorderColor
          : subCategoriesLinks.propTypes.subCatHoverBorderColor.default,
      };
    },
  },
};
</script>
<style lang="scss">
@import '@/SharedFe/scss/variables.scss';

$textColor: var(--textColor);
$hoverTextColor: var(--hoverTextColor);
$bgColor: var(--bgColor);
$hoverBgColor: var(--hoverBgColor);
$borderColor: var(--borderColor);
$hoverBorderColor: var(--hoverBorderColor);

.subCategoryLinks {
  padding: rem-calc(5) 0;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 80rem;

  &__list {
    text-align: center;
    margin: 0;
    padding-left: 0;
    @media (max-width: $mobile-screen-size) {
      padding: 0 8px;
      display: flex;
      max-width: 100%;
      overflow-x: scroll;
      -ms-overflow-style: none;
      white-space: nowrap;
      scrollbar-width: none;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__list.pill {
    & a {
      border-radius: 22px;
    }
  }

  &__list.button {
    & a {
      border-radius: 4px;
    }
  }

  &__item {
    display: inline-block;
    padding: 0 6px 16px;
    @media (min-width: $mobile-screen-size) {
      padding: 0 8px 16px;
    }

    & a {
      font-family: $brand-font-medium;
      color: $textColor;
      padding: 10px 11px;
      display: block;
      font-size: 14px;
      background-color: $bgColor;
      text-decoration: none;
      border: 1px solid $borderColor;
      border-radius: 22px;
      min-width: calc(30vw - 3rem);
      @media (min-width: $mobile-screen-size) {
        padding: 11px 26px;
        font-size: 16px;
        min-width: auto;
      }

      &:hover {
        color: $hoverTextColor;
        background-color: $hoverBgColor;
        border: 1px solid $hoverBorderColor;
      }
    }
  }
}
</style>
